import * as Long from "long";
import { ofType } from "redux-observable";
import { of } from "rxjs";
import { switchMap } from "rxjs/operators";
import { IdResource } from "../../../constants/IdResource";
import { selectPVPUnitAmountByDollars } from "../../../selectors/selectPVP";
import { getResourceIcon } from "../../generic/icon/getResourceIcon";
import { IdIcon } from "../../generic/icon/IdIcon";
import { actionAddPelletsInScreenCenterAnimation, TypeActionAnimations, } from "../actionPelletAnimations";
export var epicContractFulfillAnimation = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionAnimations.AddPelletsOnContractFulfill), switchMap(function (action) {
        var rewardInfo = action.contractRewardInfo;
        var contractId = rewardInfo.contractId;
        var rewardPellets = rewardInfo.rewards.map(function (resource) { return ({
            amount: resource.amount,
            icon: getResourceIcon(resource),
        }); });
        var rewardBuffPellets = rewardInfo.rewards.map(function (resource) { return ({
            amount: resource.buffAmount || Long.ZERO,
            icon: getResourceIcon(resource),
        }); });
        rewardPellets = rewardPellets.concat(rewardBuffPellets);
        rewardPellets.push({
            amount: rewardInfo.playerXp,
            icon: IdIcon.XpIcn,
        });
        if (rewardInfo.buffPlayerXpAmount) {
            rewardPellets.push({
                amount: rewardInfo.buffPlayerXpAmount,
                icon: IdIcon.XpIcn,
            });
        }
        rewardPellets.push({
            amount: rewardInfo.marketXp,
            icon: IdIcon.MarketXpIcn,
        });
        rewardPellets.push({
            amount: selectPVPUnitAmountByDollars(state$.value, getDollarAmount(rewardInfo.rewards)),
            icon: IdIcon.BeeIcn,
        });
        if (rewardInfo.buffMarketXpAmount) {
            rewardPellets.push({
                amount: rewardInfo.buffMarketXpAmount,
                icon: IdIcon.MarketXpIcn,
            });
        }
        return of(actionAddPelletsInScreenCenterAnimation(contractId, rewardPellets));
    }));
};
var getDollarAmount = function (resources) {
    return resources
        .filter(function (resource) { return resource.id === IdResource.Money; })
        .reduce(function (accumulator, resource) {
        return accumulator.add(resource.amount).add(resource.buffAmount || Long.ZERO);
    }, Long.ZERO);
};



//////////////////
// WEBPACK FOOTER
// ./src/features/animation/epics/epicContractFulfillAnimation.ts
// module id = 1767
// module chunks = 3